"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for Discord bot management
 * Handles all operations related to Discord functionality
 */
class DiscordRoutes extends base_1.ApiBase {
    /**
     * Get Discord server join URL from the API
     * @returns Promise resolving to Discord join URL data
     * @throws Error if the API request fails
     */
    async getDiscordJoinUrl() {
        return this.apiGet(`${constants_1.ROUTES.DISCORD}/joinUrl`);
    }
    /**
     * Create Discord guild configuration for a new server
     * @param guildConfig - The guild configuration data to create
     * @returns Promise resolving to the created guild config
     * @throws Error if the API request fails or service is not authenticated
     */
    async createGuildConfig(guildConfig) {
        return this.apiPost(`${constants_1.ROUTES.DISCORD}/guild`, guildConfig);
    }
    /**
     * Update Discord guild configuration settings
     * @param guildId - The Discord guild ID to update
     * @param updates - The configuration updates to apply
     * @returns Promise resolving to the updated guild config
     * @throws Error if the API request fails or service is not authenticated
     */
    async updateGuildConfig(guildId, updates) {
        return this.apiPatch(`${constants_1.ROUTES.DISCORD}/guild/${guildId}`, updates);
    }
}
exports.DiscordRoutes = DiscordRoutes;
//# sourceMappingURL=discord.js.map